<ng-container *ngIf="(isSuperAdminRoute$ | async) === false; else superAdminView">
  <div class="powered-by-vendasta" *ngIf="shouldShowPoweredByVendasta$ | async">
    <span class="powered-by-vendasta-text">Powered by</span>
    <img class="powered-by-vendasta-logo" src="{{ vendastaLogo }}" />
  </div>

  <div class="logo">
    <ng-container *ngIf="(shouldShowAddLogo$ | async) === false; else addLogo">
      <div
        *ngIf="(shouldShowEditCapability$ | async) === true; else justLogo"
        class="logo-container"
        [ngClass]="{ 'logo-edit': hoveringLogo }"
        (mouseenter)="hoveringLogo = true"
        (mouseleave)="hoveringLogo = false"
        (click)="editLogo()"
      >
        <ng-container *ngTemplateOutlet="justLogo"></ng-container>
        <mat-icon *ngIf="hoveringLogo">create</mat-icon>
      </div>
    </ng-container>
    <ng-template #addLogo>
      <a class="logo-placeholder" *ngIf="shouldShowAddLogo$ | async" (click)="editLogo()">
        + {{ 'CUSTOMIZE_BRANDING.LOGO.TITLE' | translate }}
      </a>
    </ng-template>
  </div>
</ng-container>

<ng-template #superAdminView>
  <div class="logo-image-container">
    <img src="{{ vendastaLogo }}" />
  </div>
</ng-template>

<ng-template #justLogo>
  <div class="logo-image-container">
    <img src="{{ whiteLabelLogoUrlDisplay$ | async }}" />
  </div>
</ng-template>
